import * as withSoftLabelActions from "../actions/soft-labels";
import { EntitySoftLabels } from "../models/entity-soft-labels";

export interface State {
  entitySoftlabels: EntitySoftLabels;
  loading: boolean;
  error: string;
  loaded: boolean;
}

export const INITIAL_STATE: State = {
  entitySoftlabels: new EntitySoftLabels(),
  loading: false,
  error: null,
  loaded: false,
};

export function reducer(state: State = INITIAL_STATE, action: withSoftLabelActions.Actions): State {
  switch (action.type) {
    case withSoftLabelActions.LOAD:
      {
        return {
          ...state,
          error: null,
          loading: true
        };
    }
    case withSoftLabelActions.LOAD_COMPLETE:
    {
        return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        entitySoftlabels: action.payload
      };
    }
    case withSoftLabelActions.LOAD_ERROR:
    {
      let errorMessage: string;
      errorMessage = 'softlabels load error';
      if (action.payload.hasOwnProperty('message')) {
        errorMessage = action.payload.message;
      }
      return {
        ...state,
        error: errorMessage,
        loading: false,
        entitySoftlabels: undefined,
        loaded: false
      };
     }
    default:
    {
      return state;
    }
  }
}
